import axios from "axios";

const UseFetch = async (method, url, abortController = new AbortController(), params, paramToken = "") => {
  const signal = abortController.signal;
  const localStorage = window.localStorage.redux;
  const store = JSON.parse(localStorage);
  const token = paramToken ? paramToken : store.clinician.data.token;

  if (!token) {
    console.log("There is no token");
    return;
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const request = axios[method.toLowerCase()](
      url,
      ...(method.toLowerCase() === "get" ? [{ ...config, signal }] : [params, { ...config, signal }]),
    );
    const response = await request;
    return response;
  } catch (error) {
    throw error;
  }
};

export default UseFetch;
